import { gql } from '@edreamsodigeo/frontend-api-client';
export const GET_LOCATIONS = gql`
  query getLocations($locationsRequest: GeoServiceLocationsRequest!) {
    getLocations(locationsRequest: $locationsRequest) {
      locations {
        type
        geoNodeId
        geoNodeType
        iataCode
        countryName
        countryCode
        cityName
        cityGeoNodeId
        name
        regionName
        continent {
          name
          id
        }
        coordinates {
          latitude
          longitude
        }
      }
    }
  }
`;
